<template>
  <div class="view-contact">
    <page-header title="Contact Us"/>
    <div class="container">
      <div class="flex align-center justify-between">
        <ul class="fw-regular">
          <li>
            <icon class="inline" name="phone"><icon-phone/></icon>
            <a href="tel:+27714020616">+27 714 020 616</a>
          </li>
          <li>
            <icon class="inline" name="mail"><icon-mail/></icon>
            <a href="mailto:wisterialodge11@gmail.com">wisterialodge11@gmail.com</a>
          </li>
          <li>
            <icon class="inline" name="location"><icon-location/></icon>11 Tafelboom Road, Weltevreden Park, Roodepoort, South Africa
          </li>
          <li>
            <icon class="inline" name="facebook"><icon-facebook/></icon>
            <a href="https://www.facebook.com/Wisteria-Lodge-279275569152881/" target="_blank">Visit our Facebook page!</a>
          </li>
        </ul>
        <div class="contact-map">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3582.675936812944!2d27.929181315185932!3d-26.109495166470964!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e957566b730e0f7%3A0x73580a7ad8af0616!2s11+Tafelboom+Rd%2C+Weltevredenpark%2C+Roodepoort%2C+1709!5e0!3m2!1sen!2sza!4v1555664909634!5m2!1sen!2sza" width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>



// WEBPACK FOOTER //
// src/components/views/Contact.vue